import script from "./MoveDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoveDialog.vue?vue&type=script&lang=ts&setup=true"

import "./MoveDialog.vue?vue&type=style&index=0&id=55e1cc02&lang=scss&scoped=true"
import "./MoveDialog.vue?vue&type=style&index=1&id=55e1cc02&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e1cc02"]])

export default __exports__